"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselScrollContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _CarouselScrollContainer = require("./CarouselScrollContainer.styles");
var _excluded = ["enableSnap", "scrollOffset", "slideGap", "hasFocusableContent"];
/**
 * The scrollable container for `Carousel` slides. Used by `Carousel`.
 *
 * Note that `role="list"` is explicitly set to force VoiceOver to announce this
 * as a list [source](https://www.tempertemper.net/blog/accessibility-issues-when-removing-list-markers).
 *
 * @since 8.71.0
 */
var CarouselScrollContainer = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var enableSnap = _ref.enableSnap,
    scrollOffset = _ref.scrollOffset,
    slideGap = _ref.slideGap,
    hasFocusableContent = _ref.hasFocusableContent,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_CarouselScrollContainer.StyledCarouselScrollContainer, (0, _extends2.default)({
    as: "ul",
    display: "flex",
    enableSnap: enableSnap,
    gap: slideGap,
    scrollOffset: scrollOffset,
    ref: forwardedRef,
    role: "list",
    tabIndex: hasFocusableContent ? undefined : 0
  }, rest));
});
exports.CarouselScrollContainer = CarouselScrollContainer;
CarouselScrollContainer.displayName = 'CarouselScrollContainer';
CarouselScrollContainer.propTypes = {
  /**
   * When true, the carousel will "snap" to the nearest slide after the user
   * clicks a nav control or finishes scrolling or swiping.
   *
   * By default, snap is enabled on desktop but disabled on mobile to protect
   * touch users from clunky, unexpected behavior. If needed, this can be changed
   * using an inline media query object.
   *
   * See the `slideAlign` and `scrollOffset` props for more controls.
   */
  enableSnap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.bool),
  /**
   * When false, the Carousel's content area will be focusable so that
   * users can control the container's scroll position with their keyboard
   */
  hasFocusableContent: _propTypes.default.bool,
  /**
   * Sets padding at the beginning and end of the slide container. Useful for preventing
   * box shadows from getting cropped.
   *
   * Takes a spacing t-shirt size or number multiplier. Defaults to 'xs'.
   *
   * Supports inline media query objects.
   */
  scrollOffset: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
  /**
   * Sets the gutter size between slides.
   *
   * Takes a spacing t-shirt size or number multiplier. Defaults to 'xs'.
   *
   * Supports inline media query objects.
   */
  slideGap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))
};
CarouselScrollContainer.defaultProps = {
  enableSnap: {
    default: false,
    lg_gte: true
  },
  hasFocusableContent: true,
  scrollOffset: 'xs',
  slideGap: 'sm'
};